import {
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Tabs,
  Tab,
  Box,
  Autocomplete,
  Stack,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import {
  HOSTNAME,
  INTRANETHOSTNAME,
  REPORT_HOSTNAME,
} from "../../../common-utilities/utils/end-points";
import { REST_URLS } from "../../../common-utilities/utils/end-points/pl-report";
import {
  HTTP_METHODS,
  invokeApi,
  invokeUploadFile,
} from "../../utils/http-service";
import { getOfflineData } from "../../utils/offline-services";
import { EXPENSE_ITEMS } from "./helper";
import "./index.scss";
import { tokenMainKeys, appSlugs } from "../../../../utils/constants";
import { downloadFileFromUrl } from "../../utils/common-utils";
import { toast } from "react-toastify";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import ClearIcon from "@mui/icons-material/Clear";
import FileUpload from "../../../common-utilities/core/file-uploader";
import CustomModal from "../../../common-utilities/core/modal";
import { REGIONS_LIST } from "../../../store-master/components/store-master/config";
// const itemsPerPage = 7;
import DownloadIcon from "@mui/icons-material/Download";
import UploadIcon from "@mui/icons-material/Upload";
import SendEmailIcon from "@mui/icons-material/Email";
import QtdSummary from "./qtd-summary";
import YtdSummary from "./ytd-summary";
import Trends from "./trends";
import ExpenseDashboard from "./expense-dashboard";
import ExpenseTrends from "./expense-trends";
import MtdSummary from "./mtd-summary";
import MultiSelectAutoComplete from "../../../common-utilities/components/mutli-select-autocomplete/MultiSelectAutocomplete";
import {
  CIRCLE,
  REGIONS,
  SCOPE_FILTER_TYPES,
} from "../../../operation-kpi/components/sales/helper";
import { SCOPE_TO_ID } from "../../../operation-kpi/components/sales";

const PLSummary = ({
  token = tokenMainKeys.plReport,
  slug = appSlugs.plReport,
}) => {
  const userDetails = getOfflineData("user", token) || {};
  const { role = "" } = userDetails;
  const [dateRanges, setDateRanges] = useState({});
  const [areaManagers, setAreaManagers] = useState([]);
  const [opsList, setOpsList] = useState([]);
  const [uploadDocument, setUploadDocument] = useState(false);
  const [startDate, setStartDate] = useState(null);
  // store opening date range
  const [storeOpeningStart, setStoreOpeningStart] = useState(null);
  const [storeOpeningEnd, setStoreOpeningEnd] = useState(null);
  const [isCallApi, setIsCallApi] = useState(true);
  const [plActualDate, setPlActualDate] = useState("");
  const [filterOptions, setFilterOptions] = useState({
    storeCode: [],
    type: [
      { label: "COCO Acquired", value: "COCO_ACQUIRED" },
      { label: "COCO Built", value: "COCO_BUILT" },
    ],
    region: REGIONS_LIST,
    city: [],
    circle: [],
    tier: [],
    format: [],
    selectedFilters: [],
  });
  const [filters, setFilters] = useState({
    page: 1,
    selectedFilters: [],
    expenseItem: "Revenue",
    viewSelectedFilters: [
      [
        {
          id: "region",
          value: REGIONS,
        },
        {
          id: "circle",
          value: CIRCLE,
        },
      ],
    ],
    scope: [],
    viewScope: [
      { id: "region", label: "Region", allowedRoles: [] },
      { id: "circle", label: "Circle", allowedRoles: [] },
    ],
    scopeValues: {},
    viewScopeValues: {
      Region: REGIONS,
      Circle: CIRCLE,
    },
    metric: ["Store Count", "S-MFR", "Z-MFR"],
    regionValue: [],
    circleValue: [],
    areaManagerValue: [],
    opsManagerValue: [],
    storeCodeValue: [],
    cityValue: [],
    formatValue: [],
    typeValue: [],
    priceCohortValue: [],
  });
  const [searchTrigger, setSearchTrigger] = useState(false);
  const [isDownload, setIsDownload] = useState(false);
  const [showEmailConfirmModal, setShowEmailConfirmModal] = useState(false);

  useEffect(() => {
    const selected = [];
    Object.entries(filters.scopeValues || {}).forEach(([scopeLabel, vals]) => {
      const id = SCOPE_TO_ID[scopeLabel];
      if (!id) return;
      // special case for storeOpeningDate which is an object with startDate/endDate
      if (scopeLabel === "Store Opening Date" && typeof vals === "object" && vals.startDate && vals.endDate) {
        selected.push({ id, value: vals });
      } else if (Array.isArray(vals) && vals.length > 0) {
        selected.push({ id, value: vals });
      }
    });

    // ---- VIEW FILTERS ----
    const viewSelected = [];
    Object.entries(filters.viewScopeValues || {}).forEach(
      ([scopeLabel, vals]) => {
        const id = SCOPE_TO_ID[scopeLabel];
        if (!id) return;
        if (Array.isArray(vals) && vals.length > 0) {
          viewSelected.push({ id, value: vals });
        }
      }
    );

    const stringifiedOld = JSON.stringify(filters.selectedFilters || []);
    const stringifiedNew = JSON.stringify(selected || []);
    if (stringifiedOld !== stringifiedNew) {
      setFilters((prev) => ({ ...prev, selectedFilters: selected }));
    }

    const stringifiedOldView = JSON.stringify(
      filters.viewSelectedFilters || []
    );
    const stringifiedNewView = JSON.stringify(viewSelected || []);
    if (stringifiedOldView !== stringifiedNewView) {
      setFilters((prev) => ({ ...prev, viewSelectedFilters: viewSelected }));
    }
  }, [filters.scopeValues, filters.viewScopeValues]);

  // clear date pickers when storeOpeningDate is deselected
  useEffect(() => {
    if (!filters.scope.some((s) => s.label === "Store Opening Date")) {
      setStoreOpeningStart(null);
      setStoreOpeningEnd(null);
    }
  }, [filters.scope]);

  const loadManager = () => {
    const selectedFilters = getSelectedFiltersPayload(true);
    const payload = payloadHandlerForFilters();
    invokeApi(
      HTTP_METHODS.POST,
      `${HOSTNAME}${REST_URLS.MANAGER_LIST}`,
      payload,
      {
        additionalRole: "am",
        ...selectedFilters,
      }
    ).then((response) => {
      if (response?.length > 0) {
        setAreaManagers(
          response.map((r) => {
            return {
              ...r,
              label: r.name,
              value: r.id,
            };
          })
        );
      }
    });
  };
  const loadOpsManager = () => {
    const selectedFilters = getSelectedFiltersPayload(true);
    const payload = payloadHandlerForFilters();

    invokeApi(
      HTTP_METHODS.POST,
      `${INTRANETHOSTNAME}${REST_URLS.MANAGER_LIST}`,
      payload,
      { additionalRole: "opsManager", ...selectedFilters }
    )
      .then((res) => {
        if (!res.message) {
          const users =
            res?.map?.((item) => {
              return {
                label: `${item?.email ? item?.email + "- " : ""}${item.name}`,
                value: item.id,
              };
            }) || [];
          setOpsList(users);
        }
      })
      .catch((err) => {
        console.log("Error occcurred getting user list", err);
      });
  };

  const getSelectedFiltersPayload = (isPassManagerId = false) => {
    const params = {};

    filters.selectedFilters.forEach((filter) => {
      const { id, value } = filter;
      if (id !== "storeCode" && id !== "format" && id !== "storeOpeningDate") {
        if (Array.isArray(value)) {
          const mappedValues = value
            .map((v) => {
              if (isPassManagerId && (id === "am" || id === "opsManager")) {
                return v?.id ?? v;
              }
              return v?.value ?? v;
            })
            .filter(Boolean);

          if (mappedValues.length > 0) {
            params[id] = mappedValues;
          }
        } else if (value !== undefined && value !== null && value !== "") {
          let val;
          if (isPassManagerId && (id === "am" || id === "opsManager")) {
            val = value?.id ?? value;
          } else {
            val = value?.value ?? value;
          }

          if (val !== undefined && val !== null && val !== "") {
            params[id] = val;
          }
        }
      }
    });

    return params;
  };

  const payloadHandler = (isView = false) => {
    const payload = {};
    if (isView) {
      (filters.viewSelectedFilters || []).forEach((filter) => {
        if (Array.isArray(filter.value) && filter.value.length > 0) {
          payload[filter.id] = filter.value.map((v) => v.value ?? v);
        }
      });
    } else {
      (filters.selectedFilters || []).forEach((filter) => {
        // special handling for storeOpeningDate - pass object directly
        if (filter.id === "storeOpeningDate" && typeof filter.value === "object" && filter.value !== null) {
          if (filter.value.startDate && filter.value.endDate) {
            payload[filter.id] = filter.value;
          }
        } else if (Array.isArray(filter.value) && filter.value.length > 0) {
          payload[filter.id] = filter.value.map((v) => v.value ?? v);
        }
      });
    }

    return payload;
  };

  // payload handler for filters API - excludes storeOpeningDate
  const payloadHandlerForFilters = (isView = false) => {
    const payload = {};
    if (isView) {
      (filters.viewSelectedFilters || []).forEach((filter) => {
        if (Array.isArray(filter.value) && filter.value.length > 0) {
          payload[filter.id] = filter.value.map((v) => v.value ?? v);
        }
      });
    } else {
      (filters.selectedFilters || []).forEach((filter) => {
        // skip storeOpeningDate for filters API
        // if (filter.id === "storeOpeningDate") return;
        if (Array.isArray(filter.value) && filter.value.length > 0) {
          payload[filter.id] = filter.value.map((v) => v.value ?? v);
        }
        if (typeof filter.value === "object" && filter.value !== null) {
          if (filter.value.startDate && filter.value.endDate) {
            payload[filter.id] = filter.value;
          }
        }
      });
    }

    return payload;
  };

  const downloadInputFile = () => {
    let params = {};
    let payload = {};
    if (dateRanges?.startMonth && dateRanges?.startYear) {
      params.date = `${dateRanges?.startMonth}/01/${dateRanges?.startYear}`;
    }
    // Apply selected filters (skip storeOpeningDate)
    (filters.selectedFilters || []).forEach((filter) => {
      if (filter.id === "storeOpeningDate") return;
      if (Array.isArray(filter.value) && filter.value.length > 0) {
        payload[filter.id] = filter.value.map((v) => v.value ?? v);
      }
    });

    params["isDownload"] = true;

    invokeApi(
      HTTP_METHODS.POST,
      `${REPORT_HOSTNAME}${REST_URLS.INPUT_FILE_SUMMARY}`,
      payload,
      params,
      null,
      slug,
      token
    )
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        }
        if (response.url) {
          downloadFileFromUrl(response.url);
        }
      })
      .catch((err) => {});
  };

  const sendEmailSummary = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${REPORT_HOSTNAME}${REST_URLS.SEND_EMAILS}`,
      null,
      null,
      null,
      slug,
      token
    )
      .then(() => {
        toast.success("Mails initiated");
      })
      .catch((err) => {
        toast.error("Failed to initiate mails");
      });
  };

  const handleDownloadResponse = (response) => {
    if (response?.status) {
      setShowEmailConfirmModal(true);
      setIsDownload(false);
      return true; // Indicates modal was shown
    }
    return false; // Indicates normal download should proceed
  };

  const loadFilterOptions = useCallback(
    (isView = false) => {
      const payload = payloadHandlerForFilters(isView);
      invokeApi(
        HTTP_METHODS.POST,
        `${REPORT_HOSTNAME}${REST_URLS.PL_FFILTERS}`,
        payload,
        null,
        null,
        slug,
        token
      )
        .then((res) => {
          if (!res?.message) {
            const storeCode = (res?.storeName || []).map((ele) => ({
              label: `${ele.storeCode}-${ele.storeName}`,
              value: ele.storeCode,
              id: ele.storeCode,
            }));
            const city = (res?.city || []).map((ele) => ({
              label: ele,
              value: ele,
            }));
            const circle = (res?.circle || []).map((ele) => ({
              label: ele,
              value: ele,
            }));

            const format = (res?.format || []).map((ele) => ({
              label: ele,
              value: ele,
            }));
            const priceCohort = (res?.priceCohort || []).map((ele) => ({
              label: ele,
              value: ele,
            }));

            const region = (res?.region || []).map((ele) => ({
              label: ele,
              value: ele,
            }));
            const type = (res?.type || []).map((ele) => ({
              label: ele,
              value: ele,
            }));
            const tier = (res?.tier || []).map((ele) => ({
              label: ele,
              value: ele,
            }));

            setFilterOptions((prevVal) => ({
              ...prevVal,
              storeCode,
              city,
              circle,
              region,
              format,
              priceCohort,
              type,
              tier,
            }));
          }
        })
        .catch((err) => console.error(err));
    },
    [filters.selectedFilters, slug, token, filters.viewSelectedFilters]
  );
  useEffect(() => {
    if (isCallApi) {
      loadFilterOptions();
      loadManager();
      loadOpsManager();
    }
  }, [filters?.selectedFilters, isCallApi]);

  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };
  const EXPENSE_OPTIONS = EXPENSE_ITEMS.map((item) => ({
    label: item,
    value: item,
  }));
  return (
    <div className="summary-report-container">
      <div className="pl-filter-container">
        <>
          <Autocomplete
            multiple
            size="small"
            sx={{ minWidth: 300 }}
            options={SCOPE_FILTER_TYPES}
            value={filters.scope}
            onChange={(event, newValue) => {
              setFilters((prev) => {
                const newScope = newValue || [];
                const keptScopeValues = Object.fromEntries(
                  Object.entries(prev.scopeValues || {}).filter(([key]) =>
                    newScope.some((s) => s.label === key)
                  )
                );
                return {
                  ...prev,
                  scope: newScope,
                  scopeValues: keptScopeValues,
                };
              });
            }}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(option, value) =>
              option.label === value.label
            }
            renderInput={(params) => (
              <TextField {...params} label="Filters" variant="outlined" />
            )}
          />
          {(filters.scope || []).map((scopeObj) => {
            const scope = scopeObj.label;
            const currentValue = filters.scopeValues[scope] || [];

            // treat store opening date differently
            if (scope === "Store Opening Date") {
              return (
                <Stack direction="row" spacing={1} key={scope} alignItems="center">
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      label="Start Date"
                      value={storeOpeningStart}
                      onChange={(value) => {
                        setStoreOpeningStart(value);
                        const startStr = value ? value.format("YYYY-MM-DD") : null;
                        const endStr = storeOpeningEnd
                          ? storeOpeningEnd.format("YYYY-MM-DD")
                          : null;

                        // only update when both exist and valid
                        if (startStr && endStr) {
                          if (moment(endStr).isBefore(moment(startStr))) {
                            toast.error("End date must be after start date");
                            return;
                          }
                          const dateObj = { startDate: startStr, endDate: endStr };
                          setFilters((prev) => ({
                            ...prev,
                            scopeValues: {
                              ...prev.scopeValues,
                              [scope]: dateObj,
                            },
                          }));
                          setIsCallApi(true);
                        } else {
                          // clear incomplete range
                          setFilters((prev) => ({
                            ...prev,
                            scopeValues: {
                              ...prev.scopeValues,
                              [scope]: {},
                            },
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          sx={{ minWidth: 150 }}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <InputAdornment position="end">
                                {storeOpeningStart && (
                                  <IconButton
                                    onClick={() => {
                                      setStoreOpeningStart(null);
                                      setFilters((prev) => ({
                                        ...prev,
                                        scopeValues: {
                                          ...prev.scopeValues,
                                          [scope]: {},
                                        },
                                      }));
                                    }}
                                    sx={{ padding: "0px" }}
                                  >
                                    <ClearIcon fontSize="small" />
                                  </IconButton>
                                )}
                                {params.InputProps.endAdornment}
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>

                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      label="End Date"
                      value={storeOpeningEnd}
                      minDate={storeOpeningStart}
                      onChange={(value) => {
                        setStoreOpeningEnd(value);
                        const startStr = storeOpeningStart
                          ? storeOpeningStart.format("YYYY-MM-DD")
                          : null;
                        const endStr = value
                          ? value.format("YYYY-MM-DD")
                          : null;

                        if (startStr && endStr) {
                          if (moment(endStr).isBefore(moment(startStr))) {
                            toast.error("End date must be after start date");
                            return;
                          }
                          const dateObj = { startDate: startStr, endDate: endStr };
                          setFilters((prev) => ({
                            ...prev,
                            scopeValues: {
                              ...prev.scopeValues,
                              [scope]: dateObj,
                            },
                          }));
                          setIsCallApi(true);
                        } else {
                          setFilters((prev) => ({
                            ...prev,
                            scopeValues: {
                              ...prev.scopeValues,
                              [scope]: {},
                            },
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          sx={{ minWidth: 150 }}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <InputAdornment position="end">
                                {storeOpeningEnd && (
                                  <IconButton
                                    onClick={() => {
                                      setStoreOpeningEnd(null);
                                      setFilters((prev) => ({
                                        ...prev,
                                        scopeValues: {
                                          ...prev.scopeValues,
                                          [scope]: {},
                                        },
                                      }));
                                    }}
                                    sx={{ padding: "0px" }}
                                  >
                                    <ClearIcon fontSize="small" />
                                  </IconButton>
                                )}
                                {params.InputProps.endAdornment}
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              );
            }

            const optionsMap = {
              Region: filterOptions.region || [],
              Circle: filterOptions.circle || [],
              "Area Manager": areaManagers,
              "Ops Manager": opsList,
              "Store Code": filterOptions.storeCode || [],
              City: filterOptions.city || [],

              Format: filterOptions.format || [],
              Type: filterOptions.type || [],
              Cohort: filterOptions.priceCohort || [],
              Tier: filterOptions.tier || [],
            };

            const allOptions = optionsMap[scope] || [];
            return (
              <MultiSelectAutoComplete
                key={scope}
                label={scope}
                options={allOptions}
                value={currentValue}
                setIsCallApiForView={setIsCallApi}
                onChange={(newValue) => {
                  setFilters((prev) => ({
                    ...prev,
                    scopeValues: {
                      ...prev.scopeValues,
                      [scope]: newValue,
                    },
                  }));
                }}
              />
            );
          })}
        </>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            label={"Select Month and Year"}
            views={["month", "year"]}
            minDate={moment("2000-01-01")}
            maxDate={moment("2099-12-31")}
            disabled={tabIndex === 3}
            value={startDate}
            onChange={(value) => {
              if (value) {
                const year = value.year();
                const month = value.month() + 1;

                setDateRanges((prevVal) => ({
                  ...prevVal,
                  startMonth: month,
                  startYear: year,
                }));
                setStartDate(value);
              } else {
                setStartDate(null);
              }
            }}
            renderInput={(params) => (
              <TextField
                className="new-textfield"
                size="small"
                {...params}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <InputAdornment position="end">
                      {startDate && (
                        <IconButton
                          onClick={() => {
                            setStartDate(null);
                            delete dateRanges?.startMonth;
                            delete dateRanges?.startYear;
                          }}
                          sx={{ padding: "0px" }}
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      )}
                      {params.InputProps.endAdornment}
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />
        </LocalizationProvider>
        {(tabIndex === 4 || tabIndex === 5) && (
          <Autocomplete
            options={EXPENSE_OPTIONS}
            value={EXPENSE_OPTIONS.find(
              (opt) => opt.value === filters.expenseItem
            )}
            onChange={(event, newValue) => {
              setIsCallApi(false);
              setFilters((prev) => ({ ...prev, expenseItem: newValue?.value }));
            }}
            getOptionLabel={(option) => option.label}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Expense Item"
                sx={{ minWidth: "300px" }}
                size="small"
              />
            )}
          />
        )}

        <Button
          variant="contained"
          onClick={() => {
            setSearchTrigger(true);
          }}
        >
          SEARCH
        </Button>
        {tabIndex !== 4 && tabIndex !== 5 && (
          <Button
            variant="outlined"
            onClick={() => setIsDownload(true)}
            color="info"
            endIcon={<DownloadIcon />}
          >
            Download Report
          </Button>
        )}
        <Button
          variant="outlined"
          onClick={downloadInputFile}
          color="info"
          endIcon={<DownloadIcon />}
        >
          Download Input File
        </Button>
        {role?.toLowerCase() === "admin" && (
          <>
            <Button
              variant="outlined"
              onClick={() => setUploadDocument(true)}
              color="warning"
              endIcon={<UploadIcon />}
            >
              Upload Documents
            </Button>
            <Button
              variant="outlined"
              onClick={sendEmailSummary}
              color="info"
              endIcon={<SendEmailIcon />}
            >
              Send Emails
            </Button>
          </>
        )}
      </div>
      <Box sx={{ mt: 0.2, mb: 0 }}>
        <Tabs value={tabIndex} onChange={handleTabChange}>
          <Tab label="MTD Summary" />
          <Tab label="QTD Summary" />
          <Tab label="YTD Summary" />
          <Tab label="Trends" />
          <Tab label="Expense Dashboard" />
          <Tab label="Expense Trends" />
        </Tabs>
      </Box>
      {tabIndex === 0 && (
        <Box>
          <MtdSummary
            filters={filters}
            setFilters={setFilters}
            dateRanges={dateRanges}
            slug={slug}
            token={token}
            tabIndex={tabIndex}
            searchTrigger={searchTrigger}
            isDownload={isDownload}
            setIsDownload={setIsDownload}
            setSearchTrigger={setSearchTrigger}
            handleDownloadResponse={handleDownloadResponse}
          />
        </Box>
      )}

      {tabIndex === 1 && (
        <Box>
          <QtdSummary
            filters={filters}
            setFilters={setFilters}
            dateRanges={dateRanges}
            slug={slug}
            token={token}
            tabIndex={tabIndex}
            searchTrigger={searchTrigger}
            isDownload={isDownload}
            setIsDownload={setIsDownload}
            setSearchTrigger={setSearchTrigger}
            handleDownloadResponse={handleDownloadResponse}
          />
        </Box>
      )}
      {tabIndex === 2 && (
        <Box>
          <YtdSummary
            filters={filters}
            setFilters={setFilters}
            dateRanges={dateRanges}
            slug={slug}
            token={token}
            tabIndex={tabIndex}
            searchTrigger={searchTrigger}
            isDownload={isDownload}
            setIsDownload={setIsDownload}
            setSearchTrigger={setSearchTrigger}
            handleDownloadResponse={handleDownloadResponse}
          />
        </Box>
      )}
      {tabIndex === 3 && (
        <Box>
          <Trends
            filters={filters}
            setFilters={setFilters}
            dateRanges={dateRanges}
            slug={slug}
            token={token}
            tabIndex={tabIndex}
            searchTrigger={searchTrigger}
            isDownload={isDownload}
            setIsDownload={setIsDownload}
            setSearchTrigger={setSearchTrigger}
            handleDownloadResponse={handleDownloadResponse}
          />
        </Box>
      )}
      {tabIndex === 4 && (
        <Box>
          <ExpenseDashboard
            filters={filters}
            setFilters={setFilters}
            dateRanges={dateRanges}
            slug={slug}
            token={token}
            tabIndex={tabIndex}
            searchTrigger={searchTrigger}
            isDownload={isDownload}
            setIsDownload={setIsDownload}
            setSearchTrigger={setSearchTrigger}
            handleDownloadResponse={handleDownloadResponse}
          />
        </Box>
      )}
      {tabIndex === 5 && (
        <Box>
          <ExpenseTrends
            filters={filters}
            setFilters={setFilters}
            dateRanges={dateRanges}
            slug={slug}
            token={token}
            tabIndex={tabIndex}
            searchTrigger={searchTrigger}
            isDownload={isDownload}
            setIsDownload={setIsDownload}
            setSearchTrigger={setSearchTrigger}
            handleDownloadResponse={handleDownloadResponse}
          />
        </Box>
      )}
      {uploadDocument && (
        <CustomModal
          open={!!uploadDocument}
          title="Profit And Loss"
          contentClassName="pl-report-form-modal"
          onClose={() => setUploadDocument(false)}
        >
          <div className="pl-report-form">
            <TextField
              type="date"
              label="PL Actual Date"
              InputLabelProps={{ shrink: true }}
              size="small"
              sx={{ mb: 2 }}
              onChange={(e) => {
                setPlActualDate(e?.target?.value);
              }}
            />
            <FileUpload
              uploadText="Upload PL Actual"
              id="pl-actual"
              fullWidth={true}
              clsName="pl-spidle-upload-file"
              uploadCallback={(data, success, failure) => {
                const params = {};
                if (plActualDate) {
                  params["latestWeekDate"] = plActualDate;
                }
                invokeUploadFile(
                  `${REPORT_HOSTNAME}${REST_URLS.PL_ACTUAL}`,
                  data,
                  slug,
                  token,
                  params
                )
                  .then((res) => {
                    if (res?.status === 200) {
                      success && success();
                      setPlActualDate("");
                      setSearchTrigger(true);
                    } else {
                      failure && failure();
                      toast.error(
                        (res.data && res.data.message) ||
                          res?.message ||
                          "Upload Failed"
                      );
                    }
                  })
                  .catch((err) => {
                    toast.error("Upload Failed");
                    failure && failure();
                  });
              }}
            />
            <FileUpload
              uploadText="Upload PL AOP"
              id="pl-aop"
              clsName="pl-spidle-upload-file"
              url={`${REPORT_HOSTNAME}${REST_URLS.PL_AOP}`}
              callBack={() => setSearchTrigger(true)}
            />
            <FileUpload
              uploadText="Upload PL UEM"
              id="pl-uem"
              clsName="pl-spidle-upload-file"
              url={`${REPORT_HOSTNAME}${REST_URLS.PL_UEM}`}
              callBack={() => setSearchTrigger(true)}
            />
            {/* <Button variant="outlined" onClick={() => loadData()}>
                    Submit
                  </Button> */}
          </div>
        </CustomModal>
      )}
      {showEmailConfirmModal && (
        <CustomModal
          open={showEmailConfirmModal}
          title="Request Submitted Successfully"
          onClose={() => setShowEmailConfirmModal(false)}
        >
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "48px", marginBottom: "0px" }}>✅</div>
            <h3 style={{ marginBottom: "15px", color: "#2e7d32" }}>
              Your request has been submitted successfully!
            </h3>
            <p
              style={{ marginBottom: "10px", fontSize: "16px", color: "#555" }}
            >
              Your P&L summary report is being generated and will be emailed to
              you shortly.
            </p>
            <p style={{ fontSize: "14px", color: "#777", marginTop: "20px" }}>
              Report will be sent to:{" "}
              <strong>{userDetails?.email || "your registered email"}</strong>
            </p>
            <Button
              variant="contained"
              onClick={() => setShowEmailConfirmModal(false)}
              style={{ marginTop: "25px" }}
            >
              OK
            </Button>
          </div>
        </CustomModal>
      )}
    </div>
  );
};

export default PLSummary;
